/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageEarn.vue?vue&type=template&id=1bd60971&scoped=true"
import script from "./cityPageEarn.vue?vue&type=script&lang=js"
export * from "./cityPageEarn.vue?vue&type=script&lang=js"
import style0 from "./cityPageEarn.vue?vue&type=style&index=0&id=1bd60971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd60971",
  null
  
)

export default component.exports